import script from "./ErstInfoPop.vue?vue&type=script&setup=true&lang=js"
export * from "./ErstInfoPop.vue?vue&type=script&setup=true&lang=js"

import "./ErstInfoPop.vue?vue&type=style&index=0&id=1875c94d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1875c94d"]])

export default __exports__